export default {
  title: 'Usuários',
  callBackSuccess: function () {},
  fields: [
    {
      type: 'input',
      inputType: 'text',
      label: 'ID',
      model: 'id',
      inputName: 'id',
      readonly: true,
      disabled: true,
      visible: false,
      required: false
    },
    {
      type: 'group',
      data: [
        {
          type: 'input',
          inputType: 'text',
          label: 'Login',
          model: 'login',
          group: true,
          inputName: 'login',
          readonly: false,
          disabled: true,
          visible: true,
          required: true
        },
        {
          type: 'input',
          inputType: 'password',
          label: 'Senha',
          model: 'senha',
          group: true,
          inputName: 'senha',
          readonly: false,
          disabled: true,
          visible: true,
          required: true
        }
      ]
    },
    {
      type: 'group',
      data: [
        {
          type: 'input',
          inputType: 'text',
          label: 'Nome',
          model: 'nome',
          inputName: 'nome',
          readonly: false,
          disabled: true,
          visible: true,
          required: true
        },
        {
          type: 'email',
          inputType: 'email',
          label: 'E-mail',
          model: 'email',
          inputName: 'email',
          readonly: false,
          disabled: true,
          visible: true,
          required: true
        }
      ]
    },
    {
      type: 'input',
      inputType: 'text',
      label: 'Login',
      model: 'login',
      group: true,
      inputName: 'login',
      readonly: false,
      disabled: true,
      visible: false,
      required: true
    },
    {
      type: 'select',
      label: 'Tipo',
      model: 'tipo',
      inputName: 'tipo',
      visible: true,
      required: true,
      itens: [
        {
          id: 1,
          description: 'Domtec',
          value: 'Domtec'
        },
        {
          id: 2,
          description: 'Contador',
          value: 'Contador'
        },
        {
          id: 3,
          description: 'Representante',
          value: 'Representante'
        },
        {
          id: 4,
          description: 'Administrador',
          value: 'Administrador',
        },
      ],
      readonly: false,
      disabled: true
    },
    {
      type: 'select',
      label: 'Status',
      model: 'status',
      inputName: 'status',
      visible: true,
      itens: [
        {
          id: 0,
          description: 'Inativo',
          value: 'Inativo'
        },
        {
          id: 1,
          description: 'Ativo',
          value: 'Ativo'
        }
      ],
      readonly: false,
      disabled: true,
      required: true
    },
    {
      type: 'select',
      label: 'Contador',
      model: 'contador',
      inputName: 'contador',
      visible: true,
      itens: [],
      readonly: false,
      disabled: true
    },
    {
      type: 'select',
      label: 'Representante',
      model: 'representante',
      inputName: 'representante',
      visible: true,
      itens: [],
      readonly: false,
      disabled: true
    }
  ]
}
